/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.32/esri/copyright.txt for details.
*/
import{exportGLB as o}from"./index.js";import{Node as n}from"./node.js";import{Asset as e}from"./asset.js";import{Scene as r}from"./scene.js";async function i(i,t){const s=new e,m=new r;return s.addScene(m),m.addNode(new n(i)),await o(s,{origin:i.origin,...t})}export{i as toBinaryGLTF};
